"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_1 = require("../global");
const fixedBanner = () => {
    const fixedTarget = document.getElementById("js-fixedBanner");
    const staticTarget = document.getElementById("js-staticBanner");
    let fixedPosition;
    if (fixedTarget === null && staticTarget === null)
        return;
    const onChangeMedia = () => {
        fixedPosition = staticTarget.offsetTop + staticTarget.offsetHeight;
    };
    const changeStatus = () => {
        const scrollTop = window.scrollY;
        if (location.pathname !== "/") {
            if (scrollTop > global_1.header.clientHeight) {
                fixedTarget.classList.add("is-sticky");
                fixedTarget.classList.remove("is-hidden");
            }
            else {
                fixedTarget.classList.remove("is-sticky");
                fixedTarget.classList.add("is-hidden");
            }
        }
        else {
            if (scrollTop > fixedPosition) {
                fixedTarget.classList.remove("is-hidden");
                staticTarget.classList.add("is-hidden");
                fixedTarget.classList.add("is-sticky");
            }
            else {
                fixedTarget.classList.add("is-hidden");
                staticTarget.classList.remove("is-hidden");
                fixedTarget.classList.remove("is-sticky");
            }
        }
    };
    if (location.pathname === "/") {
        onChangeMedia();
        global_1.mediaQueryLg.addEventListener("change", onChangeMedia);
    }
    window.addEventListener("scroll", () => {
        changeStatus();
    });
};
exports.default = fixedBanner;
